export const ROUTES = {
    MISCON_OVERVIEW: "/miscon_overview",
    MITRE_OVERVIEW: "/mitre_overview",
    MITRE_OVERVIEW_CATEGORY: "/mitre_overview/category",
    MISCON_OVERVIEW_CATEGORY: "/miscon_overview/category",
    MISCON_OVERVIEW_TOPIC: "/miscon_overview/topic",
    AI_SECURITY: "/ai_security",
    AI_SECURITY_CATEGORY: "/ai_security/category",
    AI_SECURITY_TOPIC: "/ai_security/topic",
    ACTION_LOG: "/action_log",
    ACTION_LOG_EXPLORE_ACTION: "/action_log/explore_action",
    BENCHMARK_CIS_ISSUES: "/benchmark/CIS/issues",
    BENCHMARK_CIS_ISSUES_MAPPING: "/benchmark/CIS/mapping",
    BENCHMARK_CIS_ISSUES_TOPIC: "/benchmark/CIS/issues/topic",
    POLICY_VALIDATION: "/policy_validation",
    POLICY_VALIDATION_GPO: "/policy_validation/gpo",
    ACTIVE_DIRECTORY: "/active_directory",
    ACTIVE_DIRECTORY_IGNORE_LIST: "/active_directory/ignore_list",
    CUSTOM_POLICY: "/custom_policy",
    CUSTOM_POLICY_POLICIES: "/custom_policy/policies",
    CUSTOM_POLICY_POLICIES_EDIT_POLICY: "/custom_policy/policies/edit_policy",
    CUSTOM_POLICY_POLICY_COMPLIANCE: "/custom_policy/policy_compliance",
    CUSTOM_POLICY_POLICY_COMPLIANCE_DEVICE: "/custom_policy/policy_compliance/device",
    CVE_DASHBOARD: "/cve_dashboard",
    CVE_OVERVIEW: "/cve_overview",
    CVE_OVERVIEW_TOPIC: "/cve_overview/topic_cve",
    APP_CONTROL: "/app_control/applications",
    SYSTEM_AND_DRIVERS: "/app_control/system_and_drivers",
    BROWSER_EXTENSIONS: "/app_control/browser_extensions",
    IDE_EXTENSIONS: "/app_control/ide_extensions",
    TOPIC_APP_CONTROL: "/app_control/applications/topic",
    TOPIC_SYSTEM_AND_DRIVERS: "/app_control/system_and_drivers/topic",
    TOPIC_BROWSER_EXTENSIONS: "/app_control/browser_extensions/topic",
    TOPIC_IDE_EXTENSIONS: "/app_control/ide_extensions/topic",
    PATCH_MANAGEMENT_OS_PATCHES: "/patch_management/os_patches",
    PATCH_MANAGEMENT_APP_PATCHES: "/patch_management/app_patches",
    PATCH_MANAGEMENT_OVERVIEW: "/patch_management/overview",
    PATCH_MANAGEMENT_TOPIC: "/patch_management/topic",
    EXECUTIVE_SUMMARY: "/exec_summary",
    INTUNE: "/intune",
    DEVICE_GROUPS: "/device_groups",
    PERMISSIONS: "/permissions",
    INTEGRATIONS: "/integrations",
    LICENSE: "/license",
    HEALTH: "/health",
    DEVICES: "/devices",
    DEVICE_INFO: "/device_info",
};
